import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { useToast } from "vue-toastification";
import { ApiResponse } from "@/utils/ApiResponse";
import { ProductoInterface } from "../../interfaces/productoInterfaces/Producto.interface";
import { ProductoCreateAction } from "../../actions/productoActions";
import { invalidateDashboardQueries } from "@/utils/helper/invalidateDashboard";
import { messageFromApiFailure } from "@/utils/apiErrorHandler";

const toast = useToast();

export function useProductoCreate(onClose?: () => void) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (formData: FormData) =>
      ProductoCreateAction(formData),

    onSuccess:async (response: ApiResponse<ProductoInterface>) => {
      await queryClient.invalidateQueries({ queryKey: ["ProductosList"] });
      toast.success("Producto creado correctamente");
       // âœ… Invalidar todo el dashboard
      await invalidateDashboardQueries(queryClient);
      if (onClose) onClose();
    },

    onError: (error: unknown) => {
      const msg = messageFromApiFailure(error, "Error al crear el producto");
      toast.error(msg, { timeout: 9000 });
    },
  });

  return {
    ...mutation,
  };
}
